export enum EDeviceType {
  /// <summary>
  /// 알수 없음
  /// </summary>
  UNKNOWN = -1,

  /// <summary>
  /// AX-ACU
  /// </summary>
  AX_ACU = 0,
  /// <summary>
  /// AccuBank5400
  /// </summary>
  ACCU_BANK_5400 = 1,
  /// <summary>
  /// AccuBank5800
  /// </summary>
  ACCU_BANK_5800 = 2,

  /// <summary>
  /// AX-PDA
  /// </summary>
  AX_PDA = 10,

  /// <summary>
  /// AX-ACU 엘리베이터용
  /// </summary>
  AX_ACU_EV = 15,
  /// <summary>
  /// AccuBank5800 엘리베이터용
  /// </summary>
  ACCU_BANK_EV_5800 = 16,

  /// <summary>
  /// AxMainServer
  /// </summary>
  MAIN_SERVER = 20,
  /// <summary>
  /// AxSyncServer
  /// </summary>
  SYNC_SERVER = 30,
  /// <summary>
  /// AxSystemShellClient
  /// </summary>
  SHELL_CLIENT = 40,
  /// <summary>
  /// Suprema 지문 서버
  /// </summary>
  FINGERPRINT_SERVER_SUPREMA = 60,

  /// <summary>
  /// AxMainServer 연동 Agent
  /// </summary>
  AX_SLA = 100,

  AX_WEB = 200
}
